module.exports = __webpack_public_path__ + "img/idCard-front.9330a806.png";